/* eslint react/prop-types: 0 */

import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Form, Input } from 'reactstrap';
import ReactSelect from 'react-select';
import { Menu, Select, Button as ButtonS } from 'semantic-ui-react';
import { SelectPerusahaan } from '../../component/Utils';
import { useSelector } from "react-redux";

export const HeaderComp = (props) => {
  const user = useSelector(state => state.main.dataUser);
  const [modal, setModal] = useState(false);
  const [ActiveItem, setActiveItem] = useState('Induk');
  const [InputData, setInputData] = useState({});
  const OptionsKategori = [
    { value: 1, label: 'Lembaga Keuangan' },
    { value: 2, label: 'Non Lembaga Keuangan' }
  ];

  const handleItemClick = (e, { name }) => setActiveItem(name);
  const toggle = () => {
    setInputData({})
    setModal(!modal)
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "kategori") {
      setInputData({
        ...InputData,
        [name]: parseInt(value)
      });
    } else if (name === "induk") {
      setInputData({
        ...InputData,
        [name]: {
          id: value
        }
      });
    } else {
      setInputData({
        ...InputData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (ActiveItem === "Induk") {
      await setInputData({ ...InputData, induk: null });
      props.postData({
        dispatch: 'POST_DATA_API',
        title: 'Perusahaan',
        path: 'perusahaan',
        body: InputData,
      });
      toggle();
    } else {
      props.postData({
        dispatch: 'POST_DATA_API',
        title: 'Perusahaan',
        path: 'perusahaan',
        body: InputData,
      });
      toggle();
    }
  };

  useEffect(() => {
    setInputData({});
  }, [ActiveItem]);

  return (
    <div className="card border-0 rounded-0">
      <div className="container py-4 px-5">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
            <h3>Perusahaan</h3>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            {user.role < 4 &&
              <ButtonS color='blue' onClick={toggle}>+ &nbsp; Tambah</ButtonS>
            }
          </div>
        </div>
      </div>


      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Tambah Perusahaan</ModalHeader>
        <ModalBody>
          <Menu pointing secondary>
            <Menu.Item
              name='Induk'
              color="blue"
              active={ActiveItem === 'Induk'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name='Anak Perusahaan'
              color="blue"
              active={ActiveItem === 'Anak Perusahaan'}
              onClick={handleItemClick}
            />
          </Menu>
          {ActiveItem === 'Induk' ?
            <Form onSubmit={handleSubmit}>
              <div className="container">
                <Input
                  className="mb-3"
                  type="text"
                  name="nama"
                  placeholder="Nama Perusahaan"
                  onChange={handleChange}
                  required />
                <ReactSelect
                  className="basic-single mb-3"
                  placeholder='Select Jenis Perusahaan'
                  isSearchable
                  required
                  options={OptionsKategori}
                  onChange={(event) => handleChange({
                    target: { name: 'kategori', type: 'select', value: event.value }
                  })}
                />
              </div>
              <Button color="primary" className="mt-4" block>Tambah</Button>{' '}
              <Button color="secondary" onClick={toggle} block>Cancel</Button>
            </Form>
            :
            <Form onSubmit={handleSubmit}>
              <div className="container">
                <Input
                  className="mb-3"
                  type="text"
                  name="nama"
                  placeholder="Nama Perusahaan"
                  onChange={handleChange}
                  required />

                <SelectPerusahaan
                  name="induk"
                  getDataPerusahaan={props.getDataPerusahaan}
                  onChange={handleChange}
                  required={true}
                  listPerusahaan={props.listPerusahaan}
                />

                <ReactSelect
                  className="basic-single mb-3"
                  placeholder='Pilih Jenis Perusahaan'
                  isSearchable
                  options={OptionsKategori}
                  onChange={(event) => handleChange({
                    target: { name: 'kategori', type: 'select', value: event.value }
                  })}
                />
              </div>
              <Button color="primary" className="mt-4" block>Tambah</Button>{' '}
              <Button color="secondary" onClick={toggle} block>Cancel</Button>
            </Form>
          }
        </ModalBody>

      </Modal>
    </div>
  );
};